import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setActiveTab } from '../../redux/features/authSlice';
import { toast } from 'react-toastify';
import { useFindParcelByOrderIDQuery } from '../../redux/api/parcelApi/parcelApi';
import CustomLoading from '../../components/CustomLoading';
import { BsFillPersonFill, BsFillTelephoneFill, BsPerson } from 'react-icons/bs';
import { FaAddressCard, FaTruckPickup, FaWeight } from 'react-icons/fa';
import { TbReportMoney, TbTruckDelivery } from 'react-icons/tb';

const OrderTracking = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [orderId, setOrderId] = useState('');
    const { data: parcelList, isLoading, refetch, isError } = useFindParcelByOrderIDQuery(orderId);
    const [filterText, setFilterText] = useState('');
    const [orderInfo, setOrderInfo] = useState([
        {
            title: 'Customer Name',
            value: '',
            iconBg: '#22B7F2',
            cardBg: '#A2DEF6',
            icon: <BsFillPersonFill />
        },
        {
            title: 'Pickup Status',
            value: '',
            iconBg: '#7C8C03',
            cardBg: '#C6CD96',
            icon: <FaTruckPickup />
        },
        {
            title: 'Delivery Status',
            value: '',
            iconBg: '#F2AE30',
            cardBg: '#F6DAA8',
            icon: <TbTruckDelivery />
        },
        {
            title: 'Weight',
            value: '',
            iconBg: '#FE0003',
            cardBg: '#FA9596',
            icon: <FaWeight />
        },
        {
            title: 'Customer Address',
            value: '',
            iconBg: '#FFCE0D',
            cardBg: '#FBE79A',
            icon: <FaAddressCard />
        },
        {
            title: 'Customer Phone',
            value: '',
            iconBg: '#00E600',
            cardBg: '#95F195',
            icon: <BsFillTelephoneFill />
        },
        {
            title: 'Collected Amount',
            value: '',
            iconBg: '#00B3B3',
            cardBg: '#95DCDC',
            icon: <TbReportMoney />
        },
        {
            title: 'Merchant Name',
            value: '',
            iconBg: '#F25C69',
            cardBg: '#F6BABF',
            icon: <BsPerson />
        },
    ]);

    const findOrderByOrderId = (e) => {
        e.preventDefault();
        if (filterText) {
            setOrderId(filterText);
            setFilterText('');
        } else {
            toast.info('Order id is required!');
        }
    }

    useEffect(() => {
        if (parcelList) {
            const updatedBankInfo = orderInfo.map(item => {
                if (item.title === 'Customer Name') {
                    return { ...item, value: parcelList?.customer_name };
                } else if (item.title === 'Pickup Status') {
                    return { ...item, value: parcelList?.pickup_status };
                } else if (item.title === 'Delivery Status') {
                    return { ...item, value: parcelList?.delivery_status };
                } else if (item.title === 'Weight') {
                    return { ...item, value: parcelList?.weight + ' kg' };
                } else if (item.title === 'Customer Address') {
                    return { ...item, value: parcelList?.customer_address };
                } else if (item.title === 'Customer Phone') {
                    return { ...item, value: parcelList?.customer_phone };
                } else if (item.title === 'Collected Amount') {
                    return { ...item, value: '৳ ' + parcelList?.collect_amount };
                } else if (item.title === 'Merchant Name') {
                    return { ...item, value: parcelList?.merchant?.name };
                }
                return item;
            });
            setOrderInfo(updatedBankInfo);
        } else {
            const updatedBankInfo = orderInfo.map(item => {
                if (item.title === 'Customer Name') {
                    return { ...item, value: '' };
                } else if (item.title === 'Pickup Status') {
                    return { ...item, value: '' };
                } else if (item.title === 'Delivery Status') {
                    return { ...item, value: '' };
                } else if (item.title === 'Weight') {
                    return { ...item, value: '' };
                } else if (item.title === 'Customer Address') {
                    return { ...item, value: '' };
                } else if (item.title === 'Customer Phone') {
                    return { ...item, value: '' };
                } else if (item.title === 'Collected Amount') {
                    return { ...item, value: '' };
                } else if (item.title === 'Merchant Name') {
                    return { ...item, value: '' };
                }
                return item;
            });
            setOrderInfo(updatedBankInfo);
        }
    }, [parcelList, orderId]);

    useEffect(() => {
        if (orderId && isError) {
            toast.error('Parcel not found!');
        }
    }, [orderId, isError]);

    useEffect(() => {
        if (orderId) {
            refetch();
        }
    }, [orderId]);

    useEffect(() => {
        if (pathname === "/order-tracking") {
            dispatch(setActiveTab("Order Tracking"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Order Tracking</div>
                    </div>
                    <form onSubmit={findOrderByOrderId} className="flex flex-row gap-4 items-center w-full md:w-fit">
                        <input
                            type="text"
                            className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                            placeholder={`Track your order by order id`}
                            onChange={(e) => setFilterText(e.target.value)}
                            value={filterText}
                        />
                        <button
                            type='submit'
                            className={`py-2 w-24 text-center border border-secondary text-secondary hover:bg-secondary bg-secondary/10  rounded  flex items-center justify-center cursor-pointer transition-all  hover:animate-pulse hover:text-white`}
                        >
                            Find
                        </button>
                    </form>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            {(orderInfo?.[0]?.value && orderId && !isError) && <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-3">
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4'>
                    {orderInfo?.map((parcel, index) => {
                        return (
                            <div key={index} className='p-3 rounded-lg flex flex-col gap-4' style={{ backgroundColor: parcel?.cardBg }}>
                                <div className='w-fit p-2 rounded-full text-white text-2xl flex justify-center items-center' style={{ backgroundColor: parcel?.iconBg }}>
                                    {parcel?.icon}
                                </div>
                                <div className='w-full mb-1'>
                                    <div className='text-text_1 text-lg font-semibold'>{parcel?.title}</div>
                                </div>
                                <div className='w-full flex justify-end'>
                                    <div className='text-text_1 text-lg'>{parcel?.value}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}

            {isLoading && <CustomLoading />}
        </div>
    )
}

export default OrderTracking